import type { ReactNode } from "react";
import type { Page } from "../lib/routes";
import { hashFor } from "../lib/routes";

// "lister" covers everything that scans/creates a listing (barcode, card, review of one
// session); "lister-history" gets its own permanent tab instead of living only inside that
// match list, because that was the actual bug — the route and page were real, but nothing in
// the nav ever linked to it, so thirty scanned sessions were reachable only by typing the URL.
// What the shop actually uses at the counter. The eBay-sniper pages — dashboard, saved
// searches, hot deals — are deliberately absent: they still RESOLVE (routes.ts keeps
// "#/dashboard", "#/searches" and "#/hot-deals" working, so bookmarks survive), they are just
// no longer linked. Putting one back is a single line here.
export const LINKS: Array<{ key: Page; label: string; hash: string; match: Page[] }> = [
  { key: "lister", label: "lister", hash: "#/lister", match: ["lister", "lister-card", "lister-review"] },
  { key: "lister-history", label: "history", hash: hashFor.history(), match: ["lister-history"] },
  { key: "settings", label: "settings", hash: "#/settings", match: ["settings"] },
];

export default function Layout({ page, children }: { page: Page; children: ReactNode }) {
  return (
    <div className="min-h-screen flex flex-col">
      <nav className="border-b border-zinc-800 px-4 py-2 text-sm font-mono">
        <div className="flex flex-wrap items-center gap-x-4 gap-y-1">
          <a href="#/lister" className="text-zinc-100 mr-2 hover:text-white">SlabHound</a>
          {LINKS.map((l) => (
            <a key={l.key} href={l.hash} className={`py-2 hover:text-zinc-100 ${l.match.includes(page) ? "text-zinc-100" : "text-zinc-500"}`}>
              {l.label}
            </a>
          ))}
        </div>
      </nav>
      <main className="flex-1">{children}</main>
    </div>
  );
}
